<div class="ds-accordion">
  <div *ngIf="isExpandAllShown">
    <button 
      *ngIf="activeIds.length !== listItems.length" 
      #expandAllButton
      class="focusable focusable__element btn btn-link p-0 mb-4"
      (click)="expandAll()">
      {{expandAllText}}
    </button>
    <button
      *ngIf="activeIds.length === listItems.length" 
      #collapseAllButton
      class="focusable focusable__element btn btn-link p-0 mb-4"
      (click)="collapseAll()">
      {{collapseAllText}}
    </button>
    <div 
      class="ds-accordion-separator" 
      [ngClass]="'ds-border-color--'+ borderColor">
    </div>
  </div>
  <div 
    (keydown.enter)="onKeydown($event)">
    <ng-content></ng-content>
  </div>
</div>